module.exports = __webpack_public_path__ + "static/media/01_Referenz_5w-50_mobile-min.fc1e837e.webp";